export default __webpack_public_path__ + "static/media/stars.ce6ccae4.svg";